(() => {
  if (customElements.get('sp-visitor-countdown')) return;
  const duration = 4765000;
  const key = 'steadypup:visitor-countdown:v1';
  const valid = (value) => Number.isFinite(value) && value > 0 && value <= Date.now();
  const read = () => {
    try { return Number(localStorage.getItem(key)); } catch { return NaN; }
  };
  let origin = read();
  if (!valid(origin)) {
    origin = Date.now();
    try { localStorage.setItem(key, String(origin)); } catch {}
  }
  class VisitorCountdown extends HTMLElement {
    connectedCallback() {
      this.value = this.querySelector('[data-countdown-value]');
      if (!this.value || this.interval) return;
      this.paint = () => {
        const stored = read();
        if (valid(stored)) origin = stored;
        const elapsed = Math.max(0, Date.now() - origin);
        const remaining = Math.ceil((duration - (elapsed % duration)) / 1000);
        this.value.textContent = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60]
          .map(value => String(value).padStart(2, '0')).join(':');
      };
      this.paint();
      this.interval = setInterval(this.paint, 250);
      document.addEventListener('visibilitychange', this.paint);
      window.addEventListener('pageshow', this.paint);
      window.addEventListener('storage', this.paint);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
      document.removeEventListener('visibilitychange', this.paint);
      window.removeEventListener('pageshow', this.paint);
      window.removeEventListener('storage', this.paint);
    }
  }
  customElements.define('sp-visitor-countdown', VisitorCountdown);
})();
